import clsx from "clsx";
import { memo, ReactNode } from "react";

interface Props {
  className?: string;
  children: string;
  required?: boolean;
  rightComponent?: () => ReactNode;
}

const Label = memo(
  ({ className, children, required, rightComponent }: Props) => {
    return (
      <label
        className={clsx(
          "flex justify-between items-center mb-1 font-bold text-14",
          className,
        )}
      >
        <span>
          {children}
          {required && <span className="text-primary"> *</span>}
        </span>
        {rightComponent && rightComponent()}
      </label>
    );
  },
);

Label.displayName = "Label";

export default Label;
